import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class SetPostAsSeenError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('SetPostAsSeenError', ...args);
    }
}
export default SetPostAsSeenError;
